import React from "react"
import { graphql } from "gatsby"
import Wrapper from '../components/Wrapper/Wrapper'
import Layout from '../components/ClientCase/ClientCase'
import Intro from '../components/ClientCase/Intro/Intro'
import Tiles from '../components/Tiles/Tiles'

export default function ClientCase({data}) {
	const {
		site: {
			siteMetadata: {
				url,
				description: siteDescription,
				title: siteTitle
			}
		}
	} = data;

	let finalSiteTitle = siteTitle;
	if(data.page.title) {
		if(data.page.uri !== '/') {
			finalSiteTitle = `${siteTitle} | ${data.page.title}`
		}
	}
	if(data.page.seo.seoTitle) {
		finalSiteTitle = `${data.page.seo.seoTitle} | ${siteTitle}`
	}
	let seo = {
		siteUrl: url,
		pageUrl: data.page.uri ? data.page.uri : url,
		siteDescription: data.page.seo.seoDescription ? data.page.seo.seoDescription : siteDescription,
		siteTitle: finalSiteTitle,
		image: data.page.seo.seoimage ? data.page.seo.seoimage.localFile.childImageSharp.fixed : false
	}

	return(
		<Wrapper seo={seo} menus={{primary: data.menuPrimary, header: data.menuHeader}} className="ClientCase">
			{
				data.page.caseContent.intro &&
				<Intro {...data.page.caseContent.intro} />
			}
			{
				data.page.caseContent.content &&
				<Layout content={data.page.caseContent.content} related={data.related} />
			}
			<div className="ClientCase-Tiles">
				<Tiles
					link={{
						url: '/fordelene-med-lovdata-pro/',
						title: 'Se flere fordeler med Lovdata Pro'
					}}
					centered={true}
					items={[
						{
							title: 'Innarbeid',
							text: 'I Lovdata Pro kan du utheve med farger, understreke tekst og legge til egne redaksjonelle merknader og lenker. Innarbeidelsene blir med om du eksporterer eller printer. Dersom du bytter arbeidsgiver eller lærested kan du få de med deg de personlige innarbeidelsene til ny bruker.',
							icon: 'Merknader',
							imagetype: 'icon'
						},
						{
							title: 'Personlige varslinger',
							text: 'Bli varslet om endringer i regelverket og nye relevante rettsavgjørelser – direkte på e-post.',
							icon: 'Varslinger',
							imagetype: 'icon'
						},
						{
							title: 'Del med andre',
							text: 'Opprett grupper og del notater, merknader eller hele dokumenter med andre.',
							icon: 'Dele',
							imagetype: 'icon'
						}
					]}
				/>
			</div>
		</Wrapper>
	)
}

export const query = graphql`
	query clientCase($id: String!) {
		site: site {
			siteMetadata {
				description
				title
				url
			}
		}
		menuHeader: wpMenu(locations: {eq: HEADER}) {
    		count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
		menuPrimary: wpMenu(locations: {eq: PRIMARY}) {
			count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
		related: allWpClientCase(limit: 8, sort: {date: DESC},filter: {id: {nin: [$id]}}) {
			edges {
				node {
					id
					title
					uri
				}
			}
		}
		page: wpClientCase(id: { eq: $id }) {
			title
			id
			uri
			seo {
				seoTitle:seotitle
				seoDescription:seodescription
				seoimage {
					localFile {
						childImageSharp{
							fixed(width: 1200, height:630, cropFocus:CENTER, quality: 80) {
								width
								height
								src
							}
						}
					}
				}
			}
			caseContent {
				intro {
					animation
					title
					leadParagraph
				}
          content {
            ... on WpClientCase_Casecontent_Content_Image {
              caption
				  image {
					altText
					localFile {
						childImageSharp {
							gatsbyImageData(width: 1500)
						}
					}
				  }
              fieldGroupName
            }
            ... on WpClientCase_Casecontent_Content_Text {
              fieldGroupName
              text
            }
				... on WpClientCase_Casecontent_Content_Cta {
              fieldGroupName
              playSymbol
				  embedActive
				  embed
				  title
              link {
					title
                url
                target
              }
            }
          }
        }
		}
	}
`